var React = require('react');

function DogLeashed (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448,244v34L320,231.61V384H272V224L38.17,41.25a16,16,0,0,1-2.8-22.45L45.19,6.18A16,16,0,0,1,67.64,3.37L320,192Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M96,192a32,32,0,0,0-64,0c0,41.66,26.83,76.85,64,90.1V496a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V384h80V224H128A32,32,0,0,1,96,192ZM320,384h32V496a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V277.55L320,231.84ZM528,96H464l-7.16-14.31A32,32,0,0,0,428.22,64H374.6L347.32,36.72C337.23,26.64,320,33.78,320,48V192l128,51.58V208h32a64,64,0,0,0,64-64V112A16,16,0,0,0,528,96ZM416,128a16,16,0,1,1,16-16A16,16,0,0,1,416,128Z","className":"fa-primary","key":2})]);
}

DogLeashed.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = DogLeashed;

DogLeashed.default = DogLeashed;
